import type { CashSummary } from './cashSummaryTypes';
import { invalidateReportsCache, reportsCacheKey } from '../../reports/infra/reportsRemoteCache';

export const CASH_SUMMARY_REMOTE_CACHE_MS = 60_000;

let remoteCache: { branchId: string; summary: CashSummary; fetchedAt: number } | null = null;

export function getCachedRemoteCashSummary(
  branchId: string,
  maxAgeMs = CASH_SUMMARY_REMOTE_CACHE_MS
): CashSummary | null {
  if (!remoteCache || remoteCache.branchId !== branchId) return null;
  if (Date.now() - remoteCache.fetchedAt >= maxAgeMs) return null;
  return remoteCache.summary;
}

export function setCachedRemoteCashSummary(branchId: string, summary: CashSummary): void {
  remoteCache = { branchId, summary, fetchedAt: Date.now() };
}

export function clearCachedRemoteCashSummary(): void {
  remoteCache = null;
}

/** Inicio del día local (misma convención que resolveCashSummary). */
export function cashSummaryTodayStartIso(now = new Date()): string {
  const todayStart = new Date(now);
  todayStart.setHours(0, 0, 0, 0);
  return todayStart.toISOString();
}

export function cashSummaryReportsCacheKey(branchId: string, todayStartIso: string): string {
  return reportsCacheKey(['cash_summary', branchId, todayStartIso]);
}

/** Invalida capa 1 (resolveCashSummary) y capa 2 (reportsRemoteRepo) para una sucursal. */
export function invalidateCashSummaryCaches(
  branchId: string,
  todayStartIso = cashSummaryTodayStartIso()
): void {
  clearCachedRemoteCashSummary();
  invalidateReportsCache(cashSummaryReportsCacheKey(branchId, todayStartIso));
}

/** Invalida todos los resúmenes de caja en reports cache (cuando no hay branchId). */
export function invalidateAllCashSummaryReportsCaches(): void {
  invalidateReportsCache('cash_summary|');
}
